import { ProprieteAffichee } from "src/app/bo/proprieteAffichee";

export class HoleCondition {
    id: number;
    shortName= '';
    description= '';
    regionId = 0;

    getProprietesAffichees() {
        let tab: ProprieteAffichee[] = [];
        tab.push(new ProprieteAffichee('id', 'GLOBAL.IDENTIFICATEUR'));
        tab.push(new ProprieteAffichee('shortName', 'PRODUCTS.NAMESHORT'));
        tab.push(new ProprieteAffichee('description', 'GLOBAL.DESCRIPTION'));

        return tab;
      }
  }
  